import React from 'react'
import { Box, Stack } from "@mui/material"

import { VideoCard, ChannelCard } from "./"

export default function Videos({ videos, flexPosition, direction }) {

  const VideoContent = videos.map((item, i) => (
    <Box key={i}>
      {item.id.videoId && <VideoCard video={item} />}
      {item.id.channelId && <ChannelCard channelDetail={item} />}
    </Box>
  ))

  return (
    <Stack
      direction={direction ? direction : "row"}
      flexWrap={"wrap"}
      justifyContent={flexPosition ? "center" : "flex-start"}
      gap={2}
    >
      {VideoContent}
    </Stack>
  )
}
